// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"8dc1f376","107":"51e49c9f","121":"bbe8122e","384":"b44c1c7d","593":"421fd441"}[chunkId] + ".chunk.js";
};